import { useEffect, useState } from "react";

export const KasadaIntegration = () => {
  const [loaded, setLoaded] = useState<boolean>(false);

  const loadKasada = () => {
    const kasadaSdkScript = document.createElement("script");
    kasadaSdkScript.setAttribute(
      "src",
      "/149e9513-01fa-4fb0-aad4-566afd725d1b/2d206a39-8ed7-437e-a3be-862e0f06eea3/p.js"
    );
    (document.head as HTMLHeadElement).appendChild(kasadaSdkScript);
  };

  const configureKasada = () => {
    (window as any)?.KPSDK?.configure([
      {
        domain: window.location.host,
        method: "*",
        path: "/lpg/offers/api/v1/*",
        protocol: "https",
      },
    ]);
  };

  useEffect(() => {
    if (!loaded) {
      window.addEventListener("kpsdk-load", () => {
        configureKasada();
      });
      loadKasada();
      setLoaded(true);
    }
  }, [loaded]);

  return null;
};
